
$('.plan-subscription').on('click',function(){
    $('.plan-one-time .single-product__plan-details-item:first-child .variant-option-value').prop('checked', true).trigger('change');
    $('.selling__plan-set-value').attr('name', 'selling_plan');
});
$('.plan-one-time').on('click',function(){
    $('.selling__plan-set-value').attr('name', '');
    $(this).find('.first-price').hide();
    $(this).find('.first-price').next().show();
    $('.prod-cart-quantity').val(1);
});

$('.single-product__add-btn').click(function(e){
  e.preventDefault();
  var $form = $('.single-product-form');
  var formData = $form.serialize();
  var $freeProductInput = $form.find('input[name="free_product"]');
  var freeProductVal = $freeProductInput.length ? $freeProductInput.val() : '';

  if ($freeProductInput.length && freeProductVal) {
    // Add main product and free product as a bundle via /cart/add.js with items array
    var mainProductId = $form.find('select[name="id"]').val();
    var mainProductQty = $form.find('input[name="quantity"]').val() || 1;
    var postData = {
      items: [
        {
          id: mainProductId,
          quantity: mainProductQty
        },
        {
          id: freeProductVal,
          quantity: 1
        }
      ]
    };
    // Add selling_plan if set
    var sellingPlan = $form.find('.selling__plan-set-value[name="selling_plan"]').val();
    if (sellingPlan) {
      postData.items[0].selling_plan = sellingPlan;
    }
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      dataType: 'json',
      contentType: 'application/json; charset=utf-8',
      data: JSON.stringify(postData),
      success: function(data) {
          window.location.href = "/cart";
      },
      error: 'addToCartFail'
    });
  } else {
    // Only add main item
    $.ajax({
      type: 'POST', 
      url: '/cart/add.js',
      dataType: 'json', 
      data: formData,
      success: function(data) {
        window.location.href = "/cart";
      },
      error: 'addToCartFail'
    });
  }
});

$(document).on('click', '.upsell-atc-btn', function(e){
    e.preventDefault();
    // var my_btn = $(this);
    $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          dataType: 'json', 
          data: $(this).closest('.upsell-product-form').serialize(),
          success: function(data) {
              // window.location.href = "/cart";
              // $(my_btn).addClass('btn_added');
              // $(my_btn).text('Added');
              sectionRendering();
          },
          error: 'addToCartFail'
      });
});

$(document).on('click', '.upsell-atc-btn-cart', function(e){
    e.preventDefault();
    // var my_btn = $(this);
    $.ajax({
          type: 'POST', 
          url: '/cart/add.js',
          dataType: 'json', 
          data: $(this).closest('.upsell-product-form').serialize(),
          success: function(data) {
              window.location.href = "/cart";
              // $(my_btn).addClass('btn_added');
              // $(my_btn).text('Added');
              // sectionRendering();
          },
          error: 'addToCartFail'
      });
})


function sectionRendering() {
  
    fetch("?section_id=main-product")
      .then((res) => res.text())
      .then((data) => {
        var upsell__html = $(data);
        var render__html = $(".upsell-selectors", upsell__html);
        $(".upsell-selectors").replaceWith(render__html);
      });
  }

  function removeItemPdpp(e , el){
    e.preventDefault();
    var variant_id = $(el).attr('data-id');
    var data = { updates: {} };
    data.updates[variant_id] = '0';
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: data,
      dataType: 'json',
      success: function(res) {
        get_pdp_details();
        sectionRendering();
      }
    });
        //  $(el).parent().parent().remove();
  }


  


function getSelectedOptionValues() {
    var selectedByPosition = {};
    $(".variant-option-value:checked").each(function () {
      var position = parseInt($(this).data("option-position"), 10);
      if (position) {
        selectedByPosition[position] = $(this).val().trim();
      }
    });
    var optionCount = parseInt($("#single_product").attr("data-option-count"), 10) || 0;
    if (!optionCount) {
      return null;
    }
    var orderedValues = [];
    for (var i = 1; i <= optionCount; i++) {
      if (!selectedByPosition[i]) {
        return null;
      }
      orderedValues.push(selectedByPosition[i]);
    }
    return orderedValues;
  }

  function selectedVarint(variantId) {
    if (!variantId) {
      return;
    }
    var url = new URL(window.location.href);
    url.searchParams.set("variant", variantId);
    window.history.replaceState({}, "", url);
  }

  function matchVariant() {
    var selectedValues = getSelectedOptionValues();
    if (!selectedValues) {
      return;
    }
    var updateValue = selectedValues.join(" / ");
    var matched = false;
    $("#single_product option").each(function () {
      var optionValue = $(this).text().trim();
      if (updateValue.toLowerCase() === optionValue.toLowerCase()) {
        $(this).prop("selected", true);
        matched = true;
        var variant__available = $(this).attr("data-variant-available");
        var prod_price = $(this).attr("var-price");
        $('.plan-one-time .single-product__plan-title p').html(prod_price);
        if(variant__available == 'false'){
            $(".single-product__btn-add").addClass("btn_disabled")
            $(".single-product__btn-add").text("BACK SOON");
        }else{
            $(".single-product__btn-add").removeClass("btn_disabled"); 
            $(".single-product__btn-add").text("ADD TO CART");
        }
        selectedVarint($(this).val());
        return false;
      }
    });
    if(!matched){
      $(".single-product__btn-add").addClass("btn_disabled").text("BACK SOON");
    }
  }


  $(".variant-option-value").change(function () {
    matchVariant();
  })
  matchVariant();

  function increment(el) {
    var input = el.previousElementSibling.querySelector('input');
    var value = parseInt(input.value);
    console.log(value)
    value = isNaN(value) ? 0 : value
    value++;
    input.value = value;
    changeQuantity(input);
  }

  // decrement quantity in cart drawer
  function decrement(el) {
    var input = el.nextElementSibling.querySelector('input');
    var value = parseInt(input.value);
    if (value > 1) {
      value = isNaN(value) ? 0 : value;
      value--;
      input.value = value;
      changeQuantity(input);
    }
  }
  function changeQuantity(input) {
    var quantity = $(input).val();
  $('.single-product__plan-details-quan input').val(quantity);
  $('.prod-cart-quantity').val(quantity);
  var price = $('.single-product__plan-details-quan input').attr('price') * quantity;
  var com_price = $('.single-product__plan-details-quan input').attr('com-price') * quantity;
  $('.plan-subscription .single-product__plan-title p span').text('£' + price / 100);
  $('.plan-subscription .single-product__plan-title p del').text('£'+com_price / 100);
  }





  //   Remove
function removeItem_cart(e , el){
  e.preventDefault();
  var variant_id = $(el).attr('data-id');
  console.log(variant_id);
  var data = { updates: {} };
  data.updates[variant_id] = '0';
  jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function(res) {
      get_cart_details_1();
    }
  });
      //  $(el).parent().parent().remove();
}
//   cart render
function get_cart_details_1(){
  fetch("?section_id="+ sectionID)
    .then((response) => response.text())
    .then((cartData) => {
      var cart_html = $(cartData);
      var cart_items = $(".cart__inner", cart_html);
      $(".cart__inner").replaceWith(cart_items);
    });
};



// Increase and decrease
function increaseItemCount_1(e, el) {
  var $input = el.previousElementSibling;
  var value = parseInt($input.value, 10);
  value = isNaN(value) ? 0 : value;
  value++;
  $input.value = value;            
  change_qty_1($input);
}

function decreaseItemCount_1(e, el) {
  var $input = el.nextElementSibling;
  var value = parseInt($input.value, 10);
  if (value > 1) {
      value = isNaN(value) ? 0 : value;
      value--;
      $input.value = value;            
      change_qty_1($input);
  }
}
//   change quantity
function change_qty_1($input){
  var variant_id = $($input).attr("data-id");
  var quantity= $($input).val();          
  var data = { updates: {} };
  data.updates[variant_id] = quantity;
  jQuery.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function(res) {               
      get_cart_details_1();
    }
  });
};